const UUID_V7_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The creation instant (epoch ms) encoded in a UUIDv7, or null for any other identifier. */
export function createdAtOfUuidV7(id: string): number | null {
  if (!UUID_V7_PATTERN.test(id)) return null;
  const hex = id.replace(/-/g, '').slice(0, 12);
  return Number.parseInt(hex, 16);
}
